module.exports = __webpack_public_path__ + "static/media/crying-emoji-emoticon-emotion-sad-smiley-svgrepo-com.647acacd.svg";